module.exports = __webpack_public_path__ + "assets/docx_mac.png";